export default __webpack_public_path__ + "static/media/wildfire001.800f7468.jpg";